export { default } from './useMediaQuery';
export * from './useMediaQuery';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/useMediaQuery/index.js
// module id = 824
// module chunks = 25